import React from 'react';
import useSetChartExport from '@components/export/useSetChartExport';
import { useMetricFilterData } from '../useMetricFilterSeries';
import useExportMetrics from './useExportMetrics';
import { pick } from 'lodash';
import { DATA_TAGS } from '../useData';

function useSetMetricSeriesExport() {
  const exportMetrics = useExportMetrics();
  const { totals, data: rows = {} }:any = useMetricFilterData({ dataTag: DATA_TAGS.metricFilter })
  const { totals: secondaryTotals, data: secondaryRows = {} }:any = useMetricFilterData({ dataTag: DATA_TAGS.secondaryMetricFilter })

  useSetChartExport({
    pageKey: 'trends',
    sectionKey: 'metrics-panel',
    widgetKey: 'mf-timeseries',
    widgetInfo: {
      title: 'Secondary Filter Timeseries',
    },
    data: pick({...rows, ...secondaryRows}, exportMetrics),
    totals: pick({...totals, ...secondaryTotals}, exportMetrics),
  });
}

export default useSetMetricSeriesExport;
